export default {
    GATEWAY_API_URL: process.env.GATEWAY_API_URL,
    GATEWAY_API_HEADERS: {},
    GATEWAY_TOKEN_AUTH_HEADER: process.env.GATEWAY_TOKEN_AUTH_HEADER,
    GATEWAY_TOKEN_REFRESH_HEADER: process.env.GATEWAY_TOKEN_REFRESH_HEADER
}



// WEBPACK FOOTER //
// ./src/config/http.js